"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FutureErrorProcessor = void 0;
exports.FutureErrorProcessor = {
    toMessage(error, $st) {
        let errorMessage = $st("trade_error_unknown");
        if (typeof (error) === "string") {
            errorMessage = error;
        }
        else if (typeof (error) === "object") {
            if (error.message) {
                errorMessage = error.message;
            }
            else {
                errorMessage = JSON.stringify(error);
            }
        }
        else {
            errorMessage = `${error}`;
        }
        if (errorMessage.startsWith("Leverage is smaller than permitted: insufficient margin balance.")) {
            errorMessage = $st("future_error_leverage_is_smaller_insufficient_margin");
        }
        else if (errorMessage.startsWith("Margin type cannot be changed if there exists open orders.")) {
            errorMessage = $st("future_error_exist_orders_to_change_margin_type");
        }
        else if (errorMessage.startsWith("Limit price can't be higher than")) {
            const price = errorMessage.substr(33) || "";
            errorMessage = $st("future_error_limit_price_need_lower", { price: price });
        }
        else if (errorMessage.startsWith("Margin is insufficient")) {
            errorMessage = $st("future_margin_insufficient");
        }
        if (error.code && error.code === 40300100) {
            errorMessage = $st("future_trade_error_had_fsa");
        }
        if (error.code && error.code === 40300200) {
            errorMessage = $st("future_spot_transfer_failed_cause_adjusting");
        }
        if (error.code && error.code === 40300970) {
            errorMessage = $st("future_trading_margin_need_low", { max: `20 USDT` });
        }
        if (error.code && error.code === 40300980) {
            errorMessage = $st("future_trading_disable_desc");
        }
        return errorMessage;
    }
};
